/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './training.module.scss';

const Category = (props) => {
  const {
    handleCategory,
    selectedCategory,
    handelNext,
    categories,
    adpCategories,
    adpCategory
  } = props;

  useEffect(() => {
    if (categories?.length && adpCategories?.length === 1) {
      if (categories?.includes(adpCategories?.[0]?.name)) {
        handleCategory(adpCategories?.[0]?.name);
        handelNext('training', 'training');
      } else {
        handelNext('application', 'application');
      }
    } else if (adpCategory) {
      handelNext('application', 'application');
    } else if (categories===false) {
      handelNext('training', 'training');
    }
  }, [adpCategories, categories, handelNext, handleCategory, adpCategory]);

  const handelNextSubmit = () => {
    const hasCategory = categories?.includes(selectedCategory);
    if (hasCategory) {
      handelNext('training', 'training');
    } else {
      handelNext('application', 'application');
    }
  };

  return (
  <div className={styles.mdContainer}>
      <div
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          pointerEvents: 'none'
        }}
      />
    {adpCategories && adpCategories?.length > 1
      ? <div class="modal-dialog" role="document" style={{ top: '30%' }}>
            <div class="modal-content p-2 py-4 border text-center ">
        <h4>Please Choose Your Category</h4>
        <div className="d-flex justify-content-center">
          <div className="mt-4">
            {adpCategories
              ?.sort((a, b) => (a.name).localeCompare(b.name))
              .map(ele => (
                <div className="d-flex align-items-baseline mr-3" key={ele.id}>
                  <input type="radio" className="mx-2" checked={selectedCategory === ele.name} onChange={() => { handleCategory(ele.name); }} name="category" />
                  <p>{`${ele.name?.slice(0, 1)?.toUpperCase()}${ele.name?.slice(1)}`}</p>
                </div>
              ))}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button className="btn btn-primary mt-4 w-25 " onClick={() => { selectedCategory && handelNextSubmit(); }}>
            <FormattedMessage id="inspections.new.next" defaultMessage="Next" />
          </button>
        </div>
            </div>
        </div>
      : ''
    }
  </div>
  );
};
export default Category;
